import React from 'react';
import styled from 'styled-components';
import { withCircleSkeleton, withTextSkeleton } from '@cld/skeleton';
import { depthCss } from '../styledHelpers';
import StyledChildrenWrapper from '../TreeNode/StyledChildrenWrapper';
import StyledToggleWrapper from '../TreeNode/StyledToggleWrapper';


const StyledTreeSkeleton = styled.div`
  display: flex;
  padding-left: ${depthCss};
  align-items: center;
  user-select: none;
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  transition: background-color 150ms, color 150ms;
  cursor: pointer;
  font-weight: ${({ depth }) => (depth > 0 ? 'normal' : '500')};
  // TODO: in 8aceee1e2f3f94af9e326a5e433b3f3d0cfff3e8 tree theme was deleted,
  //       this is dead reference, skeleton is broken, please decide if either remove dead css
  // font-size: \${t\`\${'size'}.font\`\};
  // min-height:\${t\`\${'size'}.height\`\};
`;

const Text = withTextSkeleton(styled.div``);

export const ToggleWrap = styled.div``; /*
  TODO: in 8aceee1e2f3f94af9e326a5e433b3f3d0cfff3e8 tree theme was deleted,
        this is dead reference, skeleton is broken, please decide if either remove dead css
        or create theme and revert the original look
  width: ${t`${'size'}.toggle`};
  height: ${t`${'size'}.toggle`};
`;*/

const TextWrap = styled(StyledChildrenWrapper)`
  flex-grow: 0;
  width: 70%;
  height: 50%;
  font-size: 10px;
  span {
    margin-bottom: 0 !important;
    height: 20px;
  }
`;

const Toggle = withCircleSkeleton(styled.div``);

const TreeSkeleton = ({ depth, size = 'md' }) => {
  return (
    <StyledTreeSkeleton {...{ depth, size }}>
      <StyledToggleWrapper {...{ depth, size }}>
        <ToggleWrap {...{ depth, size }}>
          <Toggle isLoading />
        </ToggleWrap>
      </StyledToggleWrapper>
      <TextWrap>
        <Text isLoading />
      </TextWrap>
    </StyledTreeSkeleton>
  );
};

export default TreeSkeleton;
